"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ToggleButton_1 = __importDefault(require("./ToggleButton"));
function ToggleButtonGroup({ children, value, onChange = () => null, }) {
    const [toggleButtons, setToggleButtons] = (0, react_1.useState)([]);
    const handleOnChange = (0, react_1.useCallback)((val) => {
        const _toggles = [...toggleButtons];
        const toggles = _toggles.map((toggle) => {
            return {
                value: toggle.value,
                isActive: toggle.value === val,
            };
        });
        setToggleButtons(toggles);
        onChange(val);
    }, [onChange, toggleButtons]);
    const mappedChildren = (0, react_1.useMemo)(() => {
        let index = 0;
        return react_1.Children.map(children, (child) => {
            if (child) {
                if (child.type === ToggleButton_1.default) {
                    const _child = (0, react_1.cloneElement)(child, {
                        onChange: handleOnChange,
                        isActive: toggleButtons[index]?.isActive,
                        index,
                    });
                    index++;
                    return _child;
                }
                else {
                    return (0, react_1.cloneElement)(child);
                }
            }
        });
    }, [children, handleOnChange, toggleButtons]);
    (0, react_1.useEffect)(() => {
        const val = react_1.Children.map(children, (child) => {
            if (child && child.type === ToggleButton_1.default) {
                return {
                    value: child.props.value,
                    isActive: child.props.value === value,
                };
            }
        });
        setToggleButtons(val);
    }, [children, value]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: mappedChildren });
}
exports.default = ToggleButtonGroup;
